import { colorLib as mpColorLib } from '@larki/mp';
import { USER_COLORS } from '../constants/color';
import { Color } from '@deck.gl/core';

const darkenHexColor = (hex: string, percent = 20) => {
  hex = hex.replace('#', '');

  // Convert the hex color to RGB
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Decrease each color component by the given percentage
  r = Math.max(0, r - r * (percent / 100));
  g = Math.max(0, g - g * (percent / 100));
  b = Math.max(0, b - b * (percent / 100));

  // Convert back to hex and return as a string
  const darkenedColor = `#${[r, g, b]
    .map((c) => Math.round(c).toString(16).padStart(2, '0'))
    .join('')}`;

  return darkenedColor;
};

const USER_COLORS_RGB = USER_COLORS.map((color) => ({
  name: color.name,
  color: mpColorLib.hexToRgb(color.color),
}));

function getUserColor(index?: number, rgb?: false): string;
function getUserColor(index?: number, rgb?: true): Color;
function getUserColor(index?: number, rgb = false): string | Color {
  const colors = rgb ? USER_COLORS_RGB : USER_COLORS;
  return colors[(index ?? 0) % colors.length].color;
}

const getColorName = (index?: number) => {
  return USER_COLORS[(index ?? 0) % USER_COLORS.length].name;
};

function rgbEquals(
  a?: [number, number, number],
  b?: [number, number, number]
): boolean {
  return !!a && !!b && a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}

function rgbToHex([r, g, b]: [number, number, number]): string {
  const h = (n: number) => n.toString(16).padStart(2, '0');
  return `#${h(r)}${h(g)}${h(b)}`.toUpperCase();
}

function hexToRgb(hex: string): [number, number, number] {
  if (typeof hex !== 'string') {
    throw new Error(`hexToRgb expected string, got ${typeof hex}`);
  }

  const c = hex.trim().replace(/^#/, '');
  if (!/^[0-9a-fA-F]{6}$/.test(c)) {
    throw new Error(`hexToRgb expected 6-digit hex, got "${hex}"`);
  }

  return [
    parseInt(c.slice(0, 2), 16),
    parseInt(c.slice(2, 4), 16),
    parseInt(c.slice(4, 6), 16),
  ];
}

export const colorLib = {
  darkenHexColor,
  getUserColor,
  getColorName,
  rgbEquals,
  rgbToHex,
  hexToRgb,
};
